<template>
   <!-- resend dialog -->
    <div id="divResend" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="myModalLabel">Confirm Resend</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <span class="font-weight-semibold">Resend email:</span> <span v-html="selectedEmail.subject"></span>
          </div>
          <div id="resendFooter" class="modal-footer">
            <button type="button" class="btn btn-secondary"
              data-dismiss="modal">Cancel</button>

            <template v-if="!privs.RD">
              <button class="btn btn-primary" @click="doResend(email.email,false)">
                <span class="glyphicons glyphicons-send"></span> Resend
              </button>
            </template>
            <template v-else-if="privs.RD">
              <div class="btn-group dropdown">
                <button
                  class="form-control btn btn-primary d-block dropdown-toggle"
                  data-loading-text="..."
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span class="glyphicons glyphicons-send"></span> Resend
                </button>
                <ul class="dropdown-menu dropdown-menu-right">
                  <li class="dropdown-item" @click="doResend(email.email,false)">
                    {{email.email}}
                  </li>
                  <li v-show="!showResendDifferent" class="dropdown-item" @click.stop="showDifferent()">
                    <span class="d-inline-block" style="width: 180px;">Send to different email...</span>
                  </li>
                  <li class="dropdown-item" v-show="showResendDifferent">
                    <div class="input-group input-group-sm" style="min-width: 180px;">
                      <input
                        type="text"
                        id="detailResend"
                        class="form-control form-control-sm"
                        placeholder="Email address"
                        v-model="differentEmailAddress"
                        autocomplete="off"
                        @keyup.enter="doResend(differentEmailAddress,true); closeDropdown();"
                      />
                      <div class="input-group-append">
                         <button class="btn btn-outline-secondary" type="button" @click="doResend(differentEmailAddress,true);">Send</button>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- /resend dialog -->
</template>
<script>
import {mapState} from 'vuex'
import Email from '@/mixins/email'
export default {
  data: function(){ return {
    email: {},
  }},
  mixins: [Email], 
  computed: {
    ...mapState({
      uiConfig: (state)=>state.user.uiConfig,
      privs: (state)=>state.user.privs,
      loading: (state)=>state.ui.loading,
      activeView: (state)=>state.ui.activeView,
      detailView: (state)=>state.ui.detailView,
      activeSubAccount: (state)=>state.ui.activeSubAccount,
      viewType: (state)=>state.ui.viewType,      
      emailsearchParams: (state)=>state.search.searchParams,
      resend: (state)=>state.search.resend,
      selectedEmail: (state)=>state.search.selectedEmail,      
    }),
  },
  mounted: function() {
    let that = this;
    $('#resendFooter').on('show.bs.dropdown', function () {
      that.showResendDifferent = false;
    })

  },
  methods: {
    show(email){
      this.email = email;
      this.$store.commit("setResendEmailAddress",null);
      this.$store.commit("setResendChange",false);
      $('#divResend').modal('show');
    },
    hide(){
      $('#divResend').modal('hide');
      this.showResendDifferent = false;
    },
    showDifferent(){
      this.showResendDifferent = true;
      this.$nextTick(()=>{
        $(`#detailResend`).focus();        
      });      
    },
    //to: to email address, different: if this is a different email address from the original
    async doResend(to,different){
      this.hide()
      //from Email mixin
      await this.resendEmail(to,this.email);
    },
    closeDropdown() {
      $('#resendFooter').dropdown('toggle');
    }

  },   
}
</script>